import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RecordIconScroll.module.css';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import { getImages } from '../Result/getImages';

interface RecordIconScrollProps {
    record: any;
    index: number;
    handleLinkClick: (event: React.MouseEvent, index: number) => void;
}

const RecordIconScroll: React.FC<RecordIconScrollProps> = React.memo(({ record, index, handleLinkClick }) => {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false);

    let imageUrl = ""; //todo: noimage
    const allImages = getImages(record);
    console.log(allImages);
    if ((allImages as any)["iconscroll"]?.length > 0) {
        imageUrl = (allImages as any)["iconscroll"][0]?.url;
    }
    console.log(imageUrl)

      
    const title = record?.data?.Record?.Title ?? t('No title');
    const recordNumber = record?.metadata?.recordnumber;
    const invNo = record?.data?.Record?.ObjectNumber;
    const [hasBeenShown, setHasBeenShown] = useState(false);
    const iconRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!hasBeenShown && iconRef.current) {
            console.log('X');
            setTimeout(() => {
                iconRef.current?.classList.add(styles.fadeIn);
                setHasBeenShown(true); // Set the state to true after the icon has been shown
            }, 50);
        }
    }, [hasBeenShown]);

    function getObjectTitle(record: any) {
        const titleData = record?.data?.Record?.Title;

        if (!titleData) return <div className={styles.row}>{t('No title')}</div>;

        if (Array.isArray(titleData)) {
            const filteredTitleData = titleData.find(data => data.rn === "1");
            if (!filteredTitleData) return <div className={styles.row}>{t('No title')}</div>;

            const title = filteredTitleData.Title;
            const titleType = filteredTitleData.TitleType;

            return (
                <div className={styles.row}>
                    {titleType ? (
                        <>
                            <span className={styles.taglabel}>{titleType} :</span> {title}
                        </>
                    ) : title}
                </div>
            );
        } else {
            if (titleData.rn !== "1") return <div className={styles.row}>{t('No title')}</div>;

            const title = titleData.Title;
            const titleType = titleData.TitleType;

            return (
                <div className={styles.row}>
                    {titleType ? (
                        <>
                            <span className={styles.taglabel}>{titleType} :</span> {title}
                        </>
                    ) : title}
                </div>
            );
        }
    }

    function getIconoTitle(record: any) {
        const titleData = record?.data?.Record?.Title;

        if (!titleData) return <div className={styles.row}>{t('No title')}</div>;

        if (Array.isArray(titleData)) {
            const filteredTitleData = titleData.find(data => data.rn === "1");
            if (!filteredTitleData) return <div className={styles.row}>{t('No title')}</div>;

            const title = filteredTitleData.Title;
            const titleType = "Historical title";

            return (
                <div className={styles.row}>
                    <span className={styles.taglabel}>{t(titleType)} :</span> {title}
                </div>
            );
        } else {
            if (titleData.rn !== "1") return <div className={styles.row}>{t('No title')}</div>;

            const title = titleData.Title;
            const titleType = "Historical title";

            return (
                <div className={styles.row}>
                    <span className={styles.taglabel}>{t(titleType)} :</span> {title}
                </div>
            );
        }
    }

    return (
        <div key={index}>
            <a
                href={`${window.location.pathname}?action=search&field=/Record/ObjectNumber&label=N°%20de%20gestion&value=${invNo}`}
                className={styles.RecordIcon}
                key={index}
                onClick={(event) => handleLinkClick(event, index)}
                onMouseDown={e => e.preventDefault()}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div className={styles.iconViewRecord}>
                    {imageUrl && <ImageWithFallback src={imageUrl} alt="Image" placeholder="ccImageProxy.ashx?filename=noimage/pas-dimage-white.png&width=180" />}
                    {isHovered && (
                        <div className={styles.hoverOverlay}>
                            <div className={styles.title}>{record?.data?.Record?.source === "objects" ? getObjectTitle(record) : getIconoTitle(record)}</div>
                            {record?.data?.Record?.Country && (
                                <>
                                    <div className={styles.staticText}>{t("record_country")}</div>
                                    {Array.isArray(record?.data?.Record?.Country)
                                        ? record?.data?.Record?.Country[0]?.Term ?? ''
                                        : record?.data?.Record?.Country?.Term ?? ''
                                    }
                                </>
                            )}
                        </div>
                    )}
                </div>
            </a>
        </div>
    );
    
});

export default RecordIconScroll;
